import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the MalgiriseklePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-malgirisekle',
  templateUrl: 'malgirisekle.html',
})
export class MalgiriseklePage {
  vWKayit: any = {};
  vwHareket: any = {};
  Hareket: any = {};
  liste = [];

  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public navParams: NavParams) {
    if (navParams.get("vwKayit") != null) {
      this.vWKayit = navParams.get("vwKayit");
      var data = new FormData();
      data.append("hareket_id", this.vWKayit);
      this.bllOrtak.islem(data, "DepoHareketGetir", "", false).then(a => {
        var sonuc = <any>a;
        this.liste = sonuc.SonucObject;
      }
      )
    }
  }

  ionViewDidLoad() {

  }
  hareketgetir() {
    var data = new FormData();
    data.append("hareket_id", this.vWKayit);
    this.bllOrtak.islem(data, "DepoHareketGetir", "", false).then(a => {
      var sonuc = <any>a;
      this.liste = sonuc.SonucObject;

    }
    )

  }
  sil(kayit) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz? Dikkatli Olun!!!").then(k => {
      var formData = new FormData();
      formData.append("ID", kayit.StokHareketID);
      formData.append("DepoID", kayit.DepoID);
      this.bllOrtak.islem(formData, "DepoHareketSil", "", false).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1)
          this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
        this.hareketgetir();
      }).catch(x => {
      })
    })
  }
  edit(kayit) {


  }
  aktarimmodal(kayit) {
    this.ortak.alertAktarimPenceresi().then(a => {
      var sonuc = <any>a;
      var values = sonuc.values;
      var Miktar = values.Miktar;
      var formData = new FormData();
      this.Hareket.Miktar = Miktar;
      this.Hareket.StokHareketID = kayit.StokHareketID;
      formData.append("hareket_id", JSON.stringify(kayit.StokHareketID));
      formData.append("Degisiklik_json", JSON.stringify(Miktar));
      this.bllOrtak.islem(formData, "DepoHareketDuzenle", "", true).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) {
        }
        else if (sonuc.Sonuc != 1) {
        }
      })
    }).catch(x => {
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/MalKayit/malgirisekle/malgirisekle.ts